// @core/api/endpoints/authn/delete_oauth2_provider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/authn';

/**
 * Delete OAuth2 provider
 * Removes an OAuth2 identity provider configuration. Users who authenticated solely through this provider may lose access and need to link alternative authentication methods.
 */
export async function DeleteOAuth2Provider(
  provider_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/oauth2/providers/:provider_id`;
  requestPath = requestPath.replace(':provider_id', encodeURIComponent(provider_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
